<template>
  <div style="display: flex; justify-content: center; align-items: center; flex-direction: column; height: 100vh;">
    <img src="/static/not-found-icon.jpg">
    <h3>404 Page Not Found</h3>
    <a class="el-button el-button--primary el-button--medium back-to-home" @click="$router.push({name: 'list-project'})">{{ $t('Back to home') }}</a>
  </div>
</template>
<script>
export default {
  name: 'Error404'
}
</script>



// WEBPACK FOOTER //
// src/components/error/404.vue